import {cn} from '@tempmee/core'
import {type HTMLAttributes, forwardRef} from 'react'
import {CardVariantsFactory} from './Variants'

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  /** Draws a 1px divider border around the surface. @default false */
  outline?: boolean
  /** Raises the surface with a persistent `elevation-1` shadow. @default false */
  elevated?: boolean
  /**
   * Raises the `elevation-1` shadow on hover and shows a pointer cursor — for
   * clickable cards. Compose with an `onClick`/`role`. @default false
   */
  interactive?: boolean
}

/**
 * A neutral content surface — white fill, 4px radius, 8px padding. The base
 * building block other components sit inside. Toggle `outline` for a divider
 * border and `elevated`/`interactive` for the `elevation-1` shadow (static or
 * on-hover). Everything else is a plain `<div>`, so it accepts any DOM props.
 */
export const Card = forwardRef<HTMLDivElement, CardProps>(
  ({outline = false, elevated = false, interactive = false, className, ...props}, ref) => (
    <div
      ref={ref}
      className={cn(CardVariantsFactory({outline, elevated, interactive}), className)}
      {...props}
    />
  ),
)
Card.displayName = 'Card'
